import {useId} from 'react';
import {IconProps} from './types';

const PersonCircle = ({fill = 'currentColor', className, width = 24, height = 24}: IconProps) => {
    const clipPathId = useId().replace(/:/g, '');

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 24 24"
            fill="none"
            className={className}
            aria-hidden
        >
            <g clipPath={`url(#${clipPathId})`}>
                <path
                    d="M9.99996 15C9.99996 15 8.49996 14.5 8.49996 12C7.67396 12 7.67396 10 8.49996 10C8.49996 9.665 6.99996 6 9.49996 6.5C9.99996 4.5 15.5 4.5 16 6.5C16.347 7.888 15.5 9.754 15.5 10C16.326 10 16.326 12 15.5 12C15.5 14.5 14 15 14 15V17.5C16.477 18.429 18.93 19.2 20.185 20.075C21.7784 18.4601 22.8586 16.41 23.2896 14.1827C23.7206 11.9554 23.4832 9.65031 22.6072 7.55758C21.7313 5.46486 20.2559 3.67797 18.3668 2.42176C16.4777 1.16556 14.2592 0.496176 11.9906 0.49784C9.72194 0.499504 7.50446 1.17214 5.61719 2.43112C3.72992 3.69009 2.25719 5.47914 1.38431 7.57315C0.511438 9.66716 0.277418 11.9726 0.711703 14.1993C1.14599 16.426 2.22917 18.4745 3.82496 20.087C5.15496 19.167 7.77696 18.341 9.99996 17.5V15Z"
                    stroke={fill}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M3.82495 20.087C4.895 21.1692 6.1693 22.0282 7.57393 22.6141C8.97856 23.2 10.4855 23.5011 12.0075 23.4999C13.5294 23.4988 15.0359 23.1955 16.4397 22.6076C17.8435 22.0196 19.1165 21.1588 20.1849 20.075"
                    stroke={fill}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id={clipPathId}>
                    <rect width="24" height="24" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};

export default PersonCircle;
